import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './pages/Login'
import OAuthCallback from './pages/OAuthCallback'
import Dashboard from './pages/Dashboard'
import Pages from './pages/Pages'
import PageBuilder from './pages/PageBuilder'
import PagePreview from './pages/PagePreview'
import BlockTypes from './pages/BlockTypes'
import EditBlockType from './pages/EditBlockType'
import Languages from './pages/Languages'
import Navigations from './pages/Navigations'
import NavigationBuilder from './pages/NavigationBuilder'
import Settings from './pages/Settings'
import Posts from './pages/Posts'
import PostEditor from './pages/PostEditor'
import PostBuilder from './pages/PostBuilder'
import Categories from './pages/Categories'
import MediaLibrary from './pages/MediaLibrary'
import Forms from './pages/Forms'
import FormBuilder from './pages/FormBuilder'
import FormSubmissions from './pages/FormSubmissions'
import Users from './pages/Users'
import UserEdit from './pages/UserEdit'
import MenuPermissions from './pages/MenuPermissions'

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />
      {isAuthenticated ? (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/pages"
            element={
              <ProtectedRoute path="/pages">
                <Pages />
              </ProtectedRoute>
            }
          />
          <Route path="/pages/:id/builder" element={<PageBuilder />} />
          <Route path="/pages/:id/preview" element={<PagePreview />} />
          <Route
            path="/posts"
            element={
              <ProtectedRoute path="/posts">
                <Posts />
              </ProtectedRoute>
            }
          />
          <Route path="/posts/:id" element={<PostBuilder />} />
          <Route path="/posts/:id/preview" element={<PagePreview />} />
          <Route
            path="/categories"
            element={
              <ProtectedRoute path="/categories">
                <Categories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/block-types"
            element={
              <ProtectedRoute path="/block-types">
                <BlockTypes />
              </ProtectedRoute>
            }
          />
          <Route path="/block-types/:id/edit" element={<EditBlockType />} />
          <Route
            path="/languages"
            element={
              <ProtectedRoute path="/languages">
                <Languages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/navigations"
            element={
              <ProtectedRoute path="/navigations">
                <Navigations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/navigations/:slug/builder"
            element={<NavigationBuilder />}
          />
          <Route
            path="/media"
            element={
              <ProtectedRoute path="/media">
                <MediaLibrary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms"
            element={
              <ProtectedRoute path="/media">
                <Forms />
              </ProtectedRoute>
            }
          />
          <Route path="/forms/:id/edit" element={<FormBuilder />} />
          <Route path="/forms/:id/submissions" element={<FormSubmissions />} />
          <Route
            path="/users"
            element={
              <ProtectedRoute path="/users">
                <Users />
              </ProtectedRoute>
            }
          />
          <Route path="/users/new" element={<UserEdit />} />
          <Route path="/users/:id/edit" element={<UserEdit />} />
          <Route
            path="/settings"
            element={
              <ProtectedRoute path="/settings">
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="/menu-permissions" element={<MenuPermissions />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  )
}

export default App
